export default __webpack_public_path__ + "static/media/aliexpress.c1d1bfde.svg";